import { UserDetails } from '@wpp-open/core'

import { facadeApi } from 'api'

export interface Params {
  email: string
}

export const fetchUserByEmailApi = ({ email }: Params) => facadeApi.get<{ data: UserDetails }>(`/users/${email}`)
